import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class BaseHttpService<T, R = T, C = T, U = C> {
	//R -> getOne - C -> create - U -> update

	protected baseUrl = '';
	protected url = '';

	constructor(protected http: HttpClient) {}

	readAll(filter?: any): Observable<ApiResponse<T>> {
		const queryParams =
			filter !== undefined ? this.setQueryParams(filter) : undefined;
		return this.http.get<ApiResponse<T>>(
			`${this.baseUrl}/${this.url}${queryParams ?? ''}`
		);
	}

	readById(id: number): Observable<R> {
		return this.http.get<R>(`${this.baseUrl}/${this.url}/${id}`);
	}

	create(data: C): Observable<C> {
		return this.http.post<C>(`${this.baseUrl}/${this.url}`, data);
	}

	update(id: number, data: U): Observable<U> {
		return this.http.put<U>(`${this.baseUrl}/${this.url}/${id}`, data);
	}

	delete(id: number): Observable<string> {
		return this.http.delete<string>(`${this.baseUrl}/${this.url}/${id}`);
	}

	/** Receives an object of key-value pairs where the key is the query param and the value is the query param value. */
	protected setQueryParams(queryParamsObj: any): string {
		const str: string[] = [];
		for (const qp in queryParamsObj) {
			if (
				Object.hasOwn(queryParamsObj, qp) &&
				queryParamsObj[qp] !== null &&
				queryParamsObj[qp] !== undefined
			) {
				str.push(
					encodeURIComponent(qp) + '=' + encodeURIComponent(queryParamsObj[qp])
				);
			}
		}
		let queryParams = '?';
		queryParams += str.join('&');
		return queryParams;
	}
}

export interface ApiResponse<T> {
	meta: {
		page: number;
		limit: number;
		count: number;
	};
	data: T[];
}

export interface ApiResponseUnpaginated<T> {
	data: T[];
}
